import script from "./BreadcrumbsBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadcrumbsBar.vue?vue&type=script&setup=true&lang=ts"

import "./BreadcrumbsBar.vue?vue&type=style&index=0&id=5d31d8a0&lang=scss"

const __exports__ = script;

export default __exports__